export default function RenewalModel() { 
    this.message = "";
    this.messageLine1 = "";
    this.messageLine2 = "";
    this.messageLine3 = "";
    this.messageLine4 = "";
    this.messageLine5 = "";
    this.messageLine6 = ""; 
    this.link = "";
    this.deleteRecord = "";
    this.setDeleteTrueDate = "";
    this.lastClickDate = "";
    this.lastClickFrom = ""; 
    this.tniUserClickRenewalByCustRefNoLogPartitionKey = "";
    this.tniUserClickRenewalByCustRefNoLogRowKey = "";
    this.partitionKey = "";
    this.rowKey = "";
    this.timestamp = "";
    this.eTag = "";
    
    this.setValue = function (data) { 
        this.message = data.Message || "";
        this.messageLine1 = data.MessageLine1 || "";
        this.messageLine2 = data.MessageLine2 || "";
        this.messageLine3 = data.MessageLine3 || "";
        this.messageLine4 = data.MessageLine4 || "";
        this.messageLine5 = data.MessageLine5 || "";
        this.messageLine6 = data.MessageLine6 || ""; 
        this.link = data.Link || ""; 
        this.deleteRecord = data.DeleteRecord || ""; 
        this.setDeleteTrueDate = data.SetDeleteTrueDate || ""; 
        this.lastClickDate = data.LastClickDate || ""; 
        this.lastClickFrom = data.LastClickFrom || ""; 
        this.tniUserClickRenewalByCustRefNoLogPartitionKey = data.TniUserClickRenewalByCustRefNoLog_PartitionKey || ""; 
        this.tniUserClickRenewalByCustRefNoLogRowKey = data.TniUserClickRenewalByCustRefNoLog_RowKey || ""; 
        this.partitionKey = data.PartitionKey || ""; 
        this.rowKey = data.RowKey || ""; 
        this.timestamp = data.Timestamp || ""; 
        this.eTag = data.ETag || ""; 
 
    };  
}
 